import {Component, OnDestroy} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import { Subscription} from "rxjs";
import {GameService} from "../../../services/game.service";
import {Game, Games} from "../../../models/game.class";
import {UserService} from "../../../services/user.service";
import {JackpotModel} from "../../../models/jackpot.model";
import {UserModel} from "../../../models/user.model";

import {TitleService} from "../../../services/title.service";
import {Publisher} from "../../../models/publisher.class";

declare var bootstrap: any;


@Component({
  selector: 'app-selected-game',
  templateUrl: './selected-game.component.html',
  styleUrls: ['./selected-game.component.scss']
})
export class SelectedGameComponent implements OnDestroy {

  // TODO implement tags as badges = search/filter/navigate by tags

  user?: UserModel | null;
  userSubs?: Subscription;

  game?: Game;
  gameSubs?: Subscription;
  // jackpotSubs?: Subscription;
  // jackpot?: JackpotModel;

  //refactored badges:
  // 1: first badge is the provider
  // 2-3-4 will be our displayCategories (by original category, tag and tags) with navigation
  // last badge will be the original category of the game by platform (NOT translated, no navigation) -> todo get more from tags[] (with displayname, and slug)
  badges: {
    publisher: Publisher | undefined,
    categories: string[],
    subcategories: string[]
  } = {publisher: undefined, categories: [], subcategories: []}

  gamesSelectionAll: Game[] = [];
  gamesSelectionByCategory: Game[] = [];
  gamesSelectionByProvider: Game[] = [];
  gamesSelectionLive: Game[] = [];
  gamesSelectionNew: Game[] = [];
  gamesSelectionTop: Game[] = [];
  gamesSelectionFeatured: Game[] = [];

  providers!: Publisher[];
  providerSubs!: Subscription;

  favouriteIds: number[] = [];
  favouritesSubs!: Subscription;




  constructor(
    private activatedRoute: ActivatedRoute,
    private gameService: GameService,
    private userService: UserService,
    private router: Router,
    private titleService: TitleService
  ) {
    this.providerSubs = this.gameService.providers$.subscribe(p => {
      this.providers = p;
    })

    this.userSubs = this.userService.userObject.subscribe(u => {
      this.user = u;
    })

    this.favouritesSubs = this.gameService.favouriteGameIds$.subscribe(favouriteIds => {
      this.favouriteIds = favouriteIds
    })

  }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(params => {
      let gameId = params.get('id') //the slug of the game

      if (gameId) {
        this.gameSubs?.unsubscribe();
        this.gameSubs = this.gameService.getGames().subscribe(async games => {
          //we will have games or [] if games are not available (logged in or LS)
          if (games.length) {
            /** conclusion:
            // all games have at least 1 displayedCategory --> this would be badges.categories[0] ( = the ex-categoryToNavigate)
            // not all has tags in our DB - especially aff games and from the logged in list, the new ones maybe
            // until we dont have well managed tags, we wont use them --> later they will be the badges.subcategories todo
            */

            this.game = games.getBySlug(gameId!);
            // console.log(this.game);
            if (this.game) {
              //we have the game - otherwise we show the noGameBlock
              this.titleService.setTitle(`Lobby / ${this.game.name}`);

              // this.getBadges(); refactored badges - not just the categories but also the logic and the order
              this.badges.publisher = this.providers.find(p => Games.fromGameArray(p.gameList).getById(this.game!.id));
              this.badges.categories = this.game.getDisplayedCategories();
              this.badges.subcategories = [this.game.category];
                // if(this.game.tags && this.game.tags.length){
               //   const extraTags = this.game.tags.filter(tag=> !this.badges.categories.includes(tag))
                //   console.log(extraTags) //later: get tags (display name, slug) from cdn, and use them as subcategories
                // }
              // console.log(this.badges)

              //set carousels - get data to send to carousel child components --> TODO do these somehow by badges
              const gamesWithoutSelectedOne = games.all.filter(g=>g.id !== this.game!.id)

              //ALL carousel
              this.gamesSelectionAll = this.gameService.pickRandomGames(gamesWithoutSelectedOne, 16);

              //LIVE carousel
              if (this.badges.categories.includes('live')) {
                this.gamesSelectionLive = this.gameService.pickRandomGames(Games.fromGameArray(gamesWithoutSelectedOne).getGamesOfCategory('live'), 16);
              }
              // console.log(this.gamesSelectionLive)

              //NEW carousel
              if (this.badges.categories.includes("new")){
                this.gamesSelectionNew = this.gameService.pickRandomGames(Games.fromGameArray(gamesWithoutSelectedOne).getGamesOfCategory('new'), 16);
              }

              //TOP carousel
              if (this.badges.categories.includes("top")){
                this.gamesSelectionTop = this.gameService.pickRandomGames(Games.fromGameArray(gamesWithoutSelectedOne).getGamesOfCategory('top'), 16);
              }

              //FEATURED carousel
              if (this.badges.categories.includes("featured")){
                this.gamesSelectionFeatured = this.gameService.pickRandomGames(Games.fromGameArray(gamesWithoutSelectedOne).getGamesOfCategory('featured'), 16);
              }

              //MORE FROM THE SAME CATEGORY carousel
              if(this.badges.categories.length){
                this.gamesSelectionByCategory = this.gameService.pickRandomGames(Games.fromGameArray(gamesWithoutSelectedOne).getGamesOfCategory(this.badges.categories[0]), 16);
              }

              //MORE FROM THE SAME PUBLISHER carousel
              this.gamesSelectionByProvider = this.gameService.pickRandomGames(gamesWithoutSelectedOne.filter(g => g.publisher === this.game?.publisher), 16);

              //get jackpots related to this game (currently no jackpots from server, for the user so this is not used) - commented out TODO refactor if needed
              // if (this.game && this.user) {
              //   this.jackpotSubs?.unsubscribe();
              //   this.jackpotSubs = this.gameService.getJackpotsForAGame(this.game.id).subscribe({
              //     next: response => {
              //       if ('result' in response && 'jackpots' in response.result) {
              //         const jackpots= response.result.jackpots as JackpotModel[];
              //         this.jackpot = jackpots.find(j => j.currency === this.user!.currency)
              //
              //         if (this.jackpot) {
              //           const jackpotSummary = this.translate.instant('SELECTED_GAME.JACKPOT_TOASTR_MESSAGE', {
              //             amount: this.jackpot.value,
              //             currency: this.jackpot.currency
              //           });
              //           this.toastr.info(jackpotSummary, this.translate.instant('SELECTED_GAME.JACKPOT_TOASTR_H1'), {
              //             enableHtml: true, toastClass: 'ngx-toastr yourclass'
              //           });
              //         } //else no jackpot for that game
              //       }
              //       // else --> invalid response structure
              //     },
              //     error: err => {
              //       let errorMessage: string = 'Could not fetch jackpots';
              //       if(err.error && err.error.message){
              //         errorMessage = err.error.message
              //       } else if (err.message){
              //         errorMessage = err.message
              //       }
              //       this.toastr.error(errorMessage, 'Error', {toastClass: 'ngx-toastr yourclass'})
              //     }
              //   })
              // }


            } else {
              // else : unexisting game-id --> show game not available section
              // + all games carousel refreshed (so these also will have launchurl)
              this.gamesSelectionAll = this.gameService.pickRandomGames(games.all, 16)
            }
          } else { //no games available: []
            // console.log('no games')
            this.router.navigate([''])
          }

        })
      }
    })
  }



  // getBadges() {
  //   if (this.game){
  //     this.badges = [
  //       { text: this.game.category, routerLink: `/games/${this.categoryToNavigate}` }
  //     ];
  //     //provider should be refactored - use Publisher instead
  //     let provider = this.providers.find(p => this.game?.publisher.toLowerCase().includes(p.name.split(" ")[0].toLowerCase()))
  //     if (!provider){
  //       this.badges.push({ text: this.game.publisher, routerLink: `/providers/${this.game.publisher.toLowerCase()}` });
  //     } else {
  //       this.badges.push({ text: this.game.publisher, routerLink: `/providers/${provider.routerLink}` });
  //     }
  //
  //
  //     if (this.game.category && this.game.category.toLowerCase() !== this.categoryTranslated.toLowerCase()) {
  //       this.badges.splice(1, 0, { text: `${this.categoryTranslated}`, routerLink: `/games/${this.categoryToNavigate}` });
  //     }
  //
  //     if (this.game.name && this.game.name.toLowerCase().includes('live')) {
  //       this.badges.splice(1, 0, { text: `${this.translate.instant('CATEGORIES.LIVE')}`, routerLink: '/games/live' });
  //     }
  //
  //     if (this.game.category && this.game.category.toLowerCase().includes("instanet")) {
  //       this.badges.push({ text: `${this.translate.instant('CATEGORIES.EXCLUSIVE')}`, routerLink: '/games/exclusive' });
  //     }
  //
  //     if (this.game.tag && this.game.tag === "NEW") {
  //       this.badges.push({ text: `${this.translate.instant('CATEGORIES.NEW')}`, routerLink: '/games/new' });
  //     }
  //     if (this.game.tag && this.game.tag === "HOT") {
  //       this.badges.push({ text: `${this.translate.instant('CATEGORIES.TOP')}`, routerLink: '/games/top' });
  //     }
  //     if (this.game.tag && this.game.tag === "FEATURED") {
  //       this.badges.push({ text: `${this.translate.instant('CATEGORIES.FEATURED')}`, routerLink: '/games/featured' });
  //     }
  //   }
  // }


  launchGame() {
    if (this.user && this.game && this.game.launchUrl){
      if(this.game.enabled !== false && this.game.disabledByPromo !== true){
        this.router.navigate(['play', this.game.slug] )
      }
      // will do nothing if the game is disabled
    } else {
      // needs login

      //deactivate Bootstrap modals preventing text input fields focus
      bootstrap.Modal.prototype._initializeFocusTrap = function () { return { activate: function () { }, deactivate: function () { } } };
      const signInModal = new bootstrap.Modal(document.getElementById('signInModal'), {})
      signInModal.show()
    }
  }


  updateNotFoundImgUrl(event: Event) {
    //   (event.target as HTMLImageElement).src = `https://placehold.co/512x512/3b3b3b/F0F0F0/png?text=game+image`;
    (event.target as HTMLImageElement).src = `https://placehold.co/512x512/3b3b3b/F0F0F0/png?text=${(event.target as HTMLImageElement).alt}`;
  }

  ngOnDestroy(): void {
    this.gameSubs?.unsubscribe();
    // this.jackpotSubs?.unsubscribe();
    this.providerSubs?.unsubscribe();
    this.userSubs?.unsubscribe();
    this.favouritesSubs.unsubscribe();
  }

}
